
<div class="visual-editor-field"
     [class.visual-editor-field-placeholder]="display() == Display.Placeholder"
     [class.visual-editor-field-outline]="display() == Display.Outline"
     [class.visual-editor-field-flat]="display() == Display.Flat"
     [class.visual-editor-field-draggable]="draggable()"
     [class.visual-editor-field-error]="!isValid()"
     [title]="title()"
     (mousedown)="onMouseDown($event, drag)"
     trgDrag
     #drag="TrgDragDirective"
     [dragDisabled]="!draggable()"
     [canDrop]="true"
     [dragPreview]="dragPreview"
     [dragPreviewSize]="dragPreviewSize"
     [dragPreviewClass]="'visual-editor-field-drag-preview'"
     [dragData]="this"
     [dragDelay]="dragDelay()"
     (draggingChange)="dragging.emit($event)"
     (trgDragEnterDrop)="enterDrop.emit($event)"
     (trgDragExitDrop)="exitDrop.emit($event)"
     #sizing>
  <div class="visual-editor-field-content">
    <div class="visual-editor-field-left">
      <span class="visual-editor-field-icon lh-12">
        <i [class]="icon()"></i>
      </span>
      <span class="visual-editor-field-text fs-12">
        @if (filterable()) {
          <text-highlight [text]="shortTitle()"
                          [pattern]="filterPattern()"
                          (matched)="filterMatch.set($event)"></text-highlight>
        }
        @else {
          <span>{{shortTitle()}}</span>
        }
      </span>
      @if (leftTemplate()) {
        <ng-container *ngTemplateOutlet="
                      leftTemplate();
                      context: { templateData: templateData(), preview: false }"></ng-container>
      }
    </div>
    <div class="visual-editor-field-right">
      @if (rightTemplate()) {
        <ng-container *ngTemplateOutlet="
                      rightTemplate();
                      context: { templateData: templateData(), preview: false }"></ng-container>
      }
    </div>
  </div>
  <ng-template #dragPreview>
    <div class="visual-editor-field">
      <div class="visual-editor-field-content">
        <div class="visual-editor-field-left">
          <span class="visual-editor-field-icon w-18 lh-12"><i [class]="icon()"></i></span>
          <span class="visual-editor-field-text fs-12">{{drawPreviewText() ?? longTitle() ?? shortTitle()}}</span>
          @if (leftTemplate()) {
            <ng-container *ngTemplateOutlet="
                          leftTemplate();
                          context: { templateData: templateData(), preview: true }"></ng-container>
          }
        </div>
        <div class="visual-editor-field-right">
          @if (rightTemplate()) {
            <ng-container *ngTemplateOutlet="
                          rightTemplate();
                          context: { templateData: templateData(), preview: true }"></ng-container>
          }
        </div>
      </div>
    </div>
  </ng-template>
</div>